import { render, staticRenderFns } from "./LeafletInformationModal.vue?vue&type=template&id=23a61549"
import script from "./LeafletInformationModal.vue?vue&type=script&lang=js"
export * from "./LeafletInformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports